var defaultStyles = function defaultStyles(_ref) {
  var colors = _ref.colors;
  return {
    container: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      height: '24px',
      justifyContent: 'flex-start',
      outline: 'none'
    },
    containerInline: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      height: '24px',
      justifyContent: 'flex-start',
      marginRight: '28px',
      outline: 'none'
    },
    containerLeft: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      height: '24px',
      justifyContent: 'space-between',
      outline: 'none'
    },
    iconStyle: {
      color: colors.darkGrey,
      cursor: 'pointer',
      fontSize: '16px'
    },
    iconStyleChecked: {
      color: colors.adminBlue,
      cursor: 'pointer',
      fontSize: '16px'
    },
    iconStyleDisabled: {
      color: colors.ultraLightGrey,
      cursor: 'not-allowed',
      fontSize: '16px'
    },
    labelStyleLeft: {
      color: colors.darkGrey,
      cursor: 'pointer',
      fontSize: '14px',
      paddingRight: '8px'
    },
    labelStyleLeftDisabled: {
      color: colors.ultraLightGrey,
      cursor: 'not-allowed',
      fontSize: '14px',
      paddingRight: '8px'
    },
    labelStyleRight: {
      color: colors.darkGrey,
      cursor: 'pointer',
      fontSize: '14px',
      paddingLeft: '8px'
    },
    labelStyleRightDisabled: {
      color: colors.ultraLightGrey,
      cursor: 'not-allowed',
      fontSize: '14px',
      paddingLeft: '8px'
    }
  };
};

export default defaultStyles;